import { useMutation, useQueryClient } from "react-query";
import { ECoursesQueryKeys } from "api/endpoints/courses";
import { addCourseToGroup } from "api/services/courses";
import { logError } from "utils/notifications";
import { TAddCourseToGroupBody } from "types/api/course";
import { TApiError } from "types/api/error";
import { TUrlParam } from "types/utils";

export const useAddCourseToGroup = () => {
  const queryClient = useQueryClient();
  return useMutation<
    void,
    TApiError,
    {
      courseId: TUrlParam;
      body: TAddCourseToGroupBody;
    }
  >(({ courseId, body }) => addCourseToGroup(courseId, body), {
    onSuccess: () => {
      queryClient.invalidateQueries(ECoursesQueryKeys.getAllCourses);
    },
    onError: (error) => logError({ error }),
    retry: false,
  });
};
